// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Production20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Production20: FC<Production20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path
                d="M12.917 10a2.917 2.917 0 1 1-5.834 0 2.917 2.917 0 0 1 5.834 0Zm-1.5 0a1.417 1.417 0 1 1-2.834 0 1.417 1.417 0 0 1 2.834 0Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
            <path
                d="M8.058 18.333a.42.42 0 0 1-.42-.365l-.264-2.093a.417.417 0 0 0-.212-.312l-.327-.182-.006-.003-.287-.167a.429.429 0 0 0-.38-.025l-1.964.817a.426.426 0 0 1-.532-.176l-1.943-3.322a.413.413 0 0 1 .11-.54l1.706-1.277a.415.415 0 0 0 .167-.332v-.712a.415.415 0 0 0-.167-.331L1.834 8.035a.413.413 0 0 1-.11-.54l1.942-3.322a.426.426 0 0 1 .532-.175l1.972.82a.43.43 0 0 0 .367-.018c.113-.06.207-.111.32-.177l.14-.081.174-.104a.418.418 0 0 0 .202-.306l.265-2.1a.42.42 0 0 1 .42-.365h3.884c.213 0 .393.156.42.365l.264 2.094c.017.13.095.246.21.312.086.05.188.11.27.16.096.059.243.14.358.203.112.06.246.066.364.018l1.974-.821a.426.426 0 0 1 .532.175l1.943 3.322a.412.412 0 0 1-.11.54l-1.715 1.284a.413.413 0 0 0-.166.314c-.013.343-.013.494-.013.57v.153c0 .13.062.253.167.332l1.705 1.278c.17.127.217.358.11.54l-1.942 3.32a.426.426 0 0 1-.532.175l-1.947-.816a.43.43 0 0 0-.374.02l-.354.198-.008.004-.267.156a.416.416 0 0 0-.204.307l-.265 2.098a.421.421 0 0 1-.42.365H8.058Zm.804-2.646.145 1.146h1.986l.146-1.151a1.916 1.916 0 0 1 .937-1.415l.267-.156.035-.02.352-.196a1.93 1.93 0 0 1 1.684-.093l1.08.453.977-1.67-.93-.697a1.915 1.915 0 0 1-.768-1.532v-.152c0-.094 0-.264.014-.628.023-.585.311-1.116.766-1.457l.94-.704-.98-1.673-1.11.462a1.923 1.923 0 0 1-1.654-.085 9.983 9.983 0 0 1-.43-.244c-.063-.039-.15-.09-.232-.138a1.922 1.922 0 0 1-.949-1.423l-.145-1.147H9.007L8.86 4.32a1.918 1.918 0 0 1-.925 1.408l-.167.1-.015.009-.13.076-.016.009a12.28 12.28 0 0 1-.362.2 1.93 1.93 0 0 1-1.652.08l-1.108-.46-.978 1.673.93.697c.48.36.768.924.768 1.532v.712c0 .608-.289 1.173-.768 1.532l-.93.697.978 1.673 1.1-.457a1.929 1.929 0 0 1 1.709.113l.279.162.318.177c.527.293.893.822.97 1.434Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Production20;
